import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=6d746e71&scoped=true"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=6d746e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d746e71",
  null
  
)

export default component.exports